// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Common - Start **/

.SearchForm-btn-oOIE2 {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-white-bg);
	color: var(--common-text-color);
	font-size: 18px;
}

.SearchForm-btnBlock-nviOW {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.SearchForm-btn-oOIE2:hover,
.SearchForm-btn-oOIE2:focus,
.SearchForm-btn-oOIE2:hover:focus {
	background: var(--primary-white-bg);
	color: var(--common-text-color);
}

.SearchForm-btnPrimary-Y5vRp {
	border-color: var(--btn-primary-bg);
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
	-webkit-box-shadow: 0px 8px 11px #31313126;
	        box-shadow: 0px 8px 11px #31313126;
}

.SearchForm-btnPrimary-Y5vRp:hover,
.SearchForm-btnPrimary-Y5vRp:focus,
.SearchForm-btnPrimary-Y5vRp:active,
.SearchForm-btnPrimary-Y5vRp:active:hover,
.SearchForm-btnPrimary-Y5vRp:active:focus {
	border-color: var(--btn-primary-bg-hover);
	background-color: var(--btn-primary-bg-hover);
	color: var(--white-text);
	-webkit-box-shadow: 0px 8px 11px #31313126;
	        box-shadow: 0px 8px 11px #31313126;
}

.SearchForm-btnPrimaryBorder-c1A9u {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
}

.SearchForm-btnPrimaryBorder-c1A9u:hover,
.SearchForm-btnPrimaryBorder-c1A9u:focus,
.SearchForm-btnPrimaryBorder-c1A9u:active,
.SearchForm-btnPrimaryBorder-c1A9u:active:hover,
.SearchForm-btnPrimaryBorder-c1A9u:active:focus {
	border-color: var(--btn-primary-bg-hover);
	color: var(--btn-primary-bg-hover);
	background-color: var(--primary-white-bg);
	-webkit-box-shadow: 0px 8px 11px #31313126;
	        box-shadow: 0px 8px 11px #31313126;

}

.SearchForm-searchPageSearchGrid-pAa6y {
	display: grid;
	grid-template-columns: 200px auto auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	background-color: var(--primary-white-bg);
	padding: 5px;
	border: 1px solid var(--search-input-border);
	border-radius: 6px;
	-webkit-box-shadow: 0px 4px 11px #0000000D;
	        box-shadow: 0px 4px 11px #0000000D;
	-webkit-column-gap: 5px;
	   -moz-column-gap: 5px;
	        column-gap: 5px;
}

.SearchForm-searchButton-ntW5Q {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 9px 0px;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-shadow: 0px 8px 11px #31313126;
	        box-shadow: 0px 8px 11px #31313126;
	border-radius: 6px;
}

.SearchForm-rightBorder-KF4Wt {
	position: relative;
}

.SearchForm-rightBorder-KF4Wt::after {
	content: '';
	position: absolute;
	width: 1px;
	height: 29px;
	background: var(--primary-border);
	right: 0px;
	top: 0px;
}

@media (max-width: 991px) and (min-width: 768px) {
	.SearchForm-searchPageSearchGrid-pAa6y {
		grid-template-columns: 160px auto 48px;
	}
}

@media screen and (max-width: 767px) {
	.SearchForm-rightBorder-KF4Wt::after {
		display: none;
	}

	.SearchForm-searchPageSearchGrid-pAa6y {
		grid-template-columns: 100%;
	}

	.SearchForm-searchButton-ntW5Q {
		margin-top: 27px;
	}

	.SearchForm-rightBorder-KF4Wt {
		border-bottom: 1px solid var(--primary-border);
		padding-bottom: 15px;
		margin-bottom: 15px;
	}
}

/** Search Form - End **/`, "",{"version":3,"sources":["webpack://./src/components/Header/HeaderLocationSearch/SearchForm/SearchForm.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;CACC,iBAAiB;CACjB,mCAAmC;CACnC,mCAAmC;CACnC,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,mCAAmC;CACnC,+BAA+B;AAChC;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;CACvC,wBAAwB;CACxB,0CAAkC;SAAlC,kCAAkC;AACnC;;AAGA;;;;;CAKC,yCAAyC;CACzC,6CAA6C;CAC7C,wBAAwB;CACxB,0CAAkC;SAAlC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;AAC1C;;AAEA;;;;;CAKC,yCAAyC;CACzC,kCAAkC;CAClC,yCAAyC;CACzC,0CAAkC;SAAlC,kCAAkC;;AAEnC;;AAEA;CACC,aAAa;CACb,sCAAsC;CACtC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yCAAyC;CACzC,YAAY;CACZ,4CAA4C;CAC5C,kBAAkB;CAClB,0CAAkC;SAAlC,kCAAkC;CAClC,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gBAAgB;CAChB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,0CAAkC;SAAlC,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,iCAAiC;CACjC,UAAU;CACV,QAAQ;AACT;;AAEA;CACC;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;CACpB;AACD;;AAEA,wBAAwB","sourcesContent":["/** Common - Start **/\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tfont-size: 18px;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n}\n\n.btnPrimary {\n\tborder-color: var(--btn-primary-bg);\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n\tbox-shadow: 0px 8px 11px #31313126;\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n\tborder-color: var(--btn-primary-bg-hover);\n\tbackground-color: var(--btn-primary-bg-hover);\n\tcolor: var(--white-text);\n\tbox-shadow: 0px 8px 11px #31313126;\n}\n\n.btnPrimaryBorder {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n\tborder-color: var(--btn-primary-bg-hover);\n\tcolor: var(--btn-primary-bg-hover);\n\tbackground-color: var(--primary-white-bg);\n\tbox-shadow: 0px 8px 11px #31313126;\n\n}\n\n.searchPageSearchGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 200px auto auto;\n\talign-items: center;\n\tbackground-color: var(--primary-white-bg);\n\tpadding: 5px;\n\tborder: 1px solid var(--search-input-border);\n\tborder-radius: 6px;\n\tbox-shadow: 0px 4px 11px #0000000D;\n\tcolumn-gap: 5px;\n}\n\n.searchButton {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 9px 0px;\n\tjustify-content: center;\n\tbox-shadow: 0px 8px 11px #31313126;\n\tborder-radius: 6px;\n}\n\n.rightBorder {\n\tposition: relative;\n}\n\n.rightBorder::after {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 1px;\n\theight: 29px;\n\tbackground: var(--primary-border);\n\tright: 0px;\n\ttop: 0px;\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n\t.searchPageSearchGrid {\n\t\tgrid-template-columns: 160px auto 48px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.rightBorder::after {\n\t\tdisplay: none;\n\t}\n\n\t.searchPageSearchGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.searchButton {\n\t\tmargin-top: 27px;\n\t}\n\n\t.rightBorder {\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t}\n}\n\n/** Search Form - End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `SearchForm-btn-oOIE2`,
	"btnBlock": `SearchForm-btnBlock-nviOW`,
	"btnPrimary": `SearchForm-btnPrimary-Y5vRp`,
	"btnPrimaryBorder": `SearchForm-btnPrimaryBorder-c1A9u`,
	"searchPageSearchGrid": `SearchForm-searchPageSearchGrid-pAa6y`,
	"searchButton": `SearchForm-searchButton-ntW5Q`,
	"rightBorder": `SearchForm-rightBorder-KF4Wt`
};
module.exports = ___CSS_LOADER_EXPORT___;
